<template>
  <div class="fccSirs">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actionsFormaPagamento"
            addFilter
            :items="lstFormaPagamento"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldFormaPagamento"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="
            formaPagamento.id === 0 ? adicionarFormaPagamento() : editarFormaPagamento()
          "
        >
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput
                extraClasses="inputLabel"
                required
                v-model="formaPagamento.tipopagamento"
                id="tipopagamento"
                >Tipo de Pagamento</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <fcc-select
                class="mb-4"
                placeholder="Selecione um tipo de retorno"
                labelField="tipoAcesso"
                valueField="tipoAcesso"
                v-model="formaPagamento.tipoacesso"
                :options="listarTipoAcesso"
                required
              >
                Tipo Acesso
              </fcc-select>
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <span
                ><toggle-button
                  @change="alteraGru(1, formaPagamento.grusimples)"
                  v-model="formaPagamento.grusimples"
                  :sync="true"
                />
                GRU Simples
              </span>
              <span
                ><toggle-button
                  @change="alteraGru(2, formaPagamento.grucobranca)"
                  v-model="formaPagamento.grucobranca"
                  :sync="true"
                />
                GRU Cobrança
              </span>
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Formas de pagamento',
      titlePDF: 'Formas de pagamento',
      titleModal: '',
      fields: [
        { key: 'id', label: 'Id', sortable: false },
        { key: 'tipopagamento', label: 'Tipo Pagamento', sortable: true },
        { key: 'actions', label: '' }
      ],
      listarTipoAcesso: [
        {
          tipoAcesso: 'Download'
        },
        {
          tipoAcesso: 'Redireciona'
        },
        {
          tipoAcesso: 'Link'
        },
        {
          tipoAcesso: 'Modal'
        }
      ],
      itemPorPage: '100',
      formaPagamento: {},
      lstFormaPagamento: [],
      actionsFormaPagamento: [
        {
          button: true,
          funcaoButton: 'editSubFormaPagamento',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteFormaPagamento',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    alteraGru(tipo = 1) {
      if (tipo == 1) {
        this.formaPagamento.grucobranca = false
      } else {
        this.formaPagamento.grusimples = false
      }
    },
    deleteFormaPagamento(_, item) {
      this.callConfirm(this.mensagemExcluir, item.tipopagamento).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlPublicacao +
                'PublicacaoTipoPagamento/ExcluirPublicacaoTipoPagamento?id=' +
                item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTipoPagamento()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    addField() {
      this.formaPagamento = {}
      this.formaPagamento.id = 0
      this.formaPagamento.tipoacesso = ''
      this.formaPagamento.url = ''
      this.titleModal = 'Adicionar tipo de Pagamento'
      this.$root.$emit('bv::show::modal', 'addFieldFormaPagamento')
    },
    editarFormaPagamento() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao + 'PublicacaoTipoPagamento/AlterarPublicacaoTipoPagamento',
          this.formaPagamento,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoPagamento()
          this.$root.$emit('bv::hide::modal', 'addFieldFormaPagamento')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    adicionarFormaPagamento() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoTipoPagamento/InserirPublicacaoTipoPagamento',
          this.formaPagamento,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoPagamento()
          this.$root.$emit('bv::hide::modal', 'addFieldFormaPagamento')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editSubFormaPagamento(_, item) {
      this.formaPagamento = { ...item }
      this.titleModal = 'Editar Forma de Pagamento'
      this.$root.$emit('bv::show::modal', 'addFieldFormaPagamento')
    },
    listarTipoPagamento() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarTipoPagamentoGenerico().then((resposta) => {
        this.lstFormaPagamento = resposta
        this.carregaTexto()
      })
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarTipoPagamento()
  }
}
</script>
